import { render, staticRenderFns } from "./BenefitStore.vue?vue&type=template&id=2e79a9cc&scoped=true"
import script from "./BenefitStore.vue?vue&type=script&lang=js"
export * from "./BenefitStore.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/benefit_store.css?vue&type=style&index=0&id=2e79a9cc&prod&scoped=true&lang=css&external"
import style1 from "./BenefitStore.vue?vue&type=style&index=1&id=2e79a9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79a9cc",
  null
  
)

export default component.exports